<div class="container-portada">
    <div class="leven">
        <div class="text">
            <h1 class="title quicksand-bold">{{data.title}}</h1>
            <h4 class="subtitle quicksand-bold">{{data.subtitle}}</h4>
        </div>
        <img class="img "  id="img-portada-incripcion" [src]="data.path" alt="">
    </div>

</div>